import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { MsalService } from '@azure/msal-angular';
import { MSALSpaAuthService } from '../../../../SGRE-shared/services/login-sso/msal-auth.service';

@Component({
    selector: 'app-homepage-section5-links',
    templateUrl: './homepage-section5-links.component.html',
    styleUrl: './homepage-section5-links.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomepageSection5LinksComponent {

  constructor(
    private globalService: GlobalService,
    private msalService: MsalService,
    private msalAuthService: MSALSpaAuthService
  ) { }

  login(): void {
    const usePopup = this.globalService.checkSmartEdit();
    this.msalAuthService.safeLogin(usePopup).catch((err: any) => {
      console.error('[Homepage Links] Login failed:', err);
    });
  }
}
